var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketRaised = function SvgTicketRaised(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    viewBox: "0 0 276 213"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82914"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h276v213H0z",
    "data-name": "Rectangle 30783"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Dog swimming"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M50.279 96.088c2.777-2.363 12.434-2.132 18.083-2.132s16.794.25 19.861 4.138-5.448 8.029-18.63 8.029-27.561-3.013-19.314-10.035",
    "data-name": "Path 49685",
    opacity: 0.53
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M205.996 107.502s20.331.435 27.663 1.673 16.664 10.254 8.5 19.745-20.257 8.383-54.53 8.383a70.96 70.96 0 0 1 18.367-29.801",
    "data-name": "Path 49686"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M76.118 111.911a95.8 95.8 0 0 0-27.1.518c-9.669 1.466-19.165 6.629-18.289 14.021 1.282 10.83 27.128 6.712 34.023 12.681s-8.131 7.712-12.346 13.961-.377 14.728 19.312 16.018 80.874 1.946 95.009.173 22.817-18.326.31-27.228c-35.142-7.159-90.919-30.144-90.919-30.144",
    "data-name": "Path 49687"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f6ff",
    d: "M216.095 116.151c0 18.269-27.179 33.079-77.8 33.079s-76.379-14.813-76.379-33.079 25.774-33.079 76.379-33.079 77.8 14.811 77.8 33.079",
    "data-name": "Path 49688"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff97c9",
    d: "M103.813 100.437s-27.8 2.8-29.8 39.96c11 19.662 54.326 15 54.326 15s-1.641-37.669 13.239-58.2c30.922 1 52.919.694 61.251 42.356 17-8.666 18.305-27.526 18.305-27.526s-8.332-26.663-20.5-29.663-31.829.667-31.829.667Z",
    "data-name": "Path 49689",
    opacity: 0.36
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83127",
    opacity: 0.64,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1ecff",
    d: "M191.993 102.711c0 8.941-18.682 16.19-53.465 16.19s-52.509-7.249-52.509-16.19 17.717-16.188 52.509-16.188 53.465 7.251 53.465 16.188",
    "data-name": "Path 49690"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M162.549 105.115s3.407 3.852 3.851 6.962.074 6.962 3.7 8.221 13.193 2 16.146-1.778.963-9.85-4.37-14.443a28.1 28.1 0 0 0-15.331-6.888Z",
    "data-name": "Path 49691"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83128",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M161.484 112.551s15.276-1.181 14.929-17.336a24.42 24.42 0 0 0-17.69 8.747Z",
    "data-name": "Path 49692"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M111.634 105.115s3.407 3.852 3.851 6.962.074 6.962 3.7 8.221 13.193 2 16.146-1.778.963-9.85-4.37-14.443a28.1 28.1 0 0 0-15.331-6.888Z",
    "data-name": "Path 49693"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83129",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M115.159 100.926s7.913 13.121 22.194 5.555a24.43 24.43 0 0 0-15.76-11.88Z",
    "data-name": "Path 49694"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8d76",
    d: "M156.514 48.465c2.083.069 8.7-.414 11.469 7.737s4.9 14.1 8.635 19.414 7.531 14.991 0 21.756a18.59 18.59 0 0 1-20.446 3.113c-4.076-2.007-8.916-5.324-7.74-16.648s4.768-18.238 5.182-24.458 1.049-8.289 2.9-10.914",
    "data-name": "Path 49695"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M137.077 42.91c10.811-.44 19.6 3.666 23.6 9.11s6.333 18.664 6.833 22.608 2.277 6.055 4.166 8.666c2.025 2.8 5.5 11.443 1.777 17.22s-9.786 7.258-16.236 4.092c-6.5 2.546-12.022 3.852-22.52 2.083S114.119 96.007 111.552 78.1c-1.481-10.369-1.5-23.034 3.472-29.626 8.284-2.274 11.814-5.156 22.053-5.564",
    "data-name": "Path 49696"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8d76",
    d: "M115.04 48.465c-2.222.074-9.332-.444-12.295 8.3s-5.252 15.109-9.258 20.812-8.073 16.072 0 23.33a19.93 19.93 0 0 0 21.923 3.328c4.37-2.148 9.554-5.7 8.3-17.85s-5.111-19.553-5.555-26.219-1.115-8.887-3.115-11.701",
    "data-name": "Path 49697"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M137.696 79.942a3 3 0 1 0-3-3 3 3 0 0 0 3 3",
    "data-name": "Path 49698"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M162.063 79.942a3 3 0 1 0-3-3 3 3 0 0 0 3 3",
    "data-name": "Path 49699"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8d76",
    d: "M132.999 69.326c-.231-1.088 2.467-2.425 3.842-3.43s3.446-1.389 4.536.444-2.645 3.557-4.022 3.851-4.114.327-4.356-.865",
    "data-name": "Path 49700"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8d76",
    d: "M165.06 68.918c.09-1-2.263-2.062-3.493-2.9s-2.983-1.065-3.729.667 2.509 3.081 3.678 3.27 3.445.063 3.544-1.037",
    "data-name": "Path 49701"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M152.277 86.794c.213-1.25 9.027-1.667 9.786 0s-1.62 5.944-4.064 5.944-6.279-2.667-5.722-5.944",
    "data-name": "Path 49702"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1c3177",
    strokeLinecap: "round",
    d: "M158.232 89.182a42.4 42.4 0 0 1-.324 7.11",
    "data-name": "Path 49703"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83130",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fec272",
    strokeLinecap: "round",
    strokeWidth: 7,
    d: "M124.081 120.308a7.25 7.25 0 0 0-.231-5.275",
    "data-name": "Path 49704"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83131",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fec272",
    strokeLinecap: "round",
    strokeWidth: 7,
    d: "M132.263 119.752a7.03 7.03 0 0 0-.625-4.719",
    "data-name": "Path 49705"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83132",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fec272",
    strokeLinecap: "round",
    strokeWidth: 7,
    d: "M174.996 120.308a7.25 7.25 0 0 0-.231-5.275",
    "data-name": "Path 49706"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 83133",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fec272",
    strokeLinecap: "round",
    strokeWidth: 7,
    d: "M183.178 119.752a7.02 7.02 0 0 0-.623-4.719",
    "data-name": "Path 49707"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M196.973 148.584c2.777-2.365 12.431-2.134 18.083-2.134s16.794.252 19.861 4.141-5.448 8.027-18.63 8.027-27.552-3.012-19.314-10.034",
    "data-name": "Path 49708",
    opacity: 0.53
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1c3177",
    strokeLinecap: "round",
    d: "M151.444 99.912c3.48 1.621 7.365 1.548 11.602-.218",
    "data-name": "Path 49709"
  })))));
};
export default SvgTicketRaised;